export const CATEGORIES = [
  { slug: "device-repair-guides", name: "Repair Guides" },
  { slug: "sell-your-phone", name: "Sell Your Phone" },
  { slug: "sell-your-laptop", name: "Sell Your Laptop" },
  { slug: "sell-your-tablet", name: "Sell Your Tablet" },
  { slug: "sell-gaming-consoles", name: "Sell Consoles" },
  { slug: "buy-refurbished", name: "Buy Refurbished" },
  { slug: "buyback-price-guides", name: "Price Guides" },
  { slug: "electronics-recycling", name: "Recycling" },
  { slug: "device-preparation-guides", name: "Device Prep" },
  { slug: "technology-news", name: "Tech News" },
  { slug: "chicago-local-guides", name: "Chicago Local" },
];

export const SITE = {
  name: "Chicago Electronics Guide",
  tagline: "The local resource for repairing, selling, trading and recycling consumer electronics.",
  url: "https://chicagoelectronicsguide.com",
  description:
    "Chicago Electronics Guide — long-form guides, real repair costs, resale values, and trustworthy resources for repairing, selling, buying refurbished, trading, and recycling phones, laptops, tablets, and gaming consoles across Chicagoland.",
  social: {
    twitter: "https://twitter.com/",
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
  },
};

export const TWOA = {
  name: "2A Electronics Service",
  website: "https://2aelectronics.com",
};
